import { createSlice } from "@reduxjs/toolkit";
import { TaxCodeResponseDto } from "../../shared/dtos/taxCode/TaxCodeResponseDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

export const taxCodeSlice = createSlice({
  name: "taxCode",
  initialState: getInitialCrudState<TaxCodeResponseDto>(),
  reducers: {
    ...generateCrudReducers<TaxCodeResponseDto>(),
  },
});

export const taxCodeActions = taxCodeSlice.actions;
export default taxCodeSlice.reducer;
